import { createFileRoute } from '@tanstack/react-router';

import { PageDemandImporter } from '@/areas/demand/Demand/DemandImporter/PageDemandImporter';
import { canOpenPartLibraryImporters } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/demands/importer')({
    staticData: { access: { permissions: canOpenPartLibraryImporters }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PageDemandImporter />;
}
